<template>
  <div class="page">
    <div class="busisness-top-box">
      <van-image
        class="hidden-img"
        :src="isHidden ? showImg : hiddenImg"
        @click="handleHiddenAmount"
      />
      <div class="top-info mt32">
        <p>人民币余额</p>
        <p class="account" v-if="isHidden">
          <span class="unit">{{ businessData.wtfyeAmountHbf || "" }}</span
          >{{ businessData.wtfyeAmount || 0 }}
        </p>
        <p class="account" v-else>********</p>
      </div>
      <div class="top-info mt12">
        <p>外币余额</p>
        <p class="account" v-if="isHidden">
          <span class="unit"> {{ businessData.wbyeAmountHbf || "" }}</span
          >{{ businessData.wbyeAmount || 0 }}
        </p>
        <p class="account" v-else>********</p>
      </div>
      <div class="main-info">
        <div class="flex-item">
          <p>未收汇金额</p>
          <p v-if="isHidden">
            <span class="unit">{{ businessData.wshAmountHbf || "" }}</span
            >{{ businessData.wshAmount || 0 }}
          </p>
          <p v-else>********</p>
        </div>
        <div class="flex-item">
          <p>未开票金额</p>
          <p v-if="isHidden">
            <span class="unit">{{ businessData.wkpAmountHbf || "" }}</span
            >{{ businessData.wkpAmount || 0 }}
          </p>
          <p v-else>********</p>
        </div>
        <div class="flex-item">
          <p>赊销融资余额</p>
          <p v-if="isHidden">
            <span class="unit">{{ businessData.InvYeAmountHbf || "" }}</span
            >{{ businessData.InvYeAmount || 0 }}
          </p>
          <p v-else>********</p>
        </div>
      </div>
    </div>
    <div>
      <div class="year-data">
        <p class="titleLine title">本年数据</p>
        <van-cell-group class="cell-group">
          <van-cell
            title="本年出口金额"
            :icon="bnckIcon"
            :value="
              `${businessData.yearAmountHbf || ''}${businessData.yearAmount ||
                0}`
            "
          >
          </van-cell>
          <van-cell
            title="本年出口订单"
            :icon="bnckddIcon"
            :value="`${businessData.ljYearAgcustAccount || 0}单`"
          />
        </van-cell-group>
      </div>
      <div class="year-data">
        <p class="titleLine title">累计数据</p>
        <van-cell-group class="cell-group">
          <van-cell
            title="国外卖家数量"
            :icon="gwmjIcon"
            :value="`${businessData.agcustCount || 0}家`"
          >
          </van-cell>
          <van-cell
            title="累计出口金额"
            :icon="ljckIcon"
            :value="
              `${businessData.amountHbf || ''}${businessData.amount || 0}`
            "
          />
          <van-cell
            title="累计出口订单"
            :icon="ljckddIcon"
            :value="`${businessData.ljAgcustAccount || 0}单`"
          />
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
import https from "../../utils/request";
export default {
  name: "index",
  props: {},
  data() {
    return {
      agcustId: localStorage.getItem("personid"), //委托方ID
      businessData: {}, //业务概况数据
      loading: false, //加载中
      bnckIcon: require("../../assets/img/bnck.png"), //本年出口金额icon
      bnckddIcon: require("../../assets/img/bnckdd.png"), //本年出口订单icon
      gwmjIcon: require("../../assets/img/gwmj.png"), //国外卖家数量icon
      ljckIcon: require("../../assets/img/ljck.png"), //累计出口金额icon
      ljckddIcon: require("../../assets/img/ljckdd.png"), //累计出口订单icon
      isHidden: true, //是否隐藏金额 true-不隐藏，false-隐藏
      showImg: require("../../assets/img/show.png"), //显示金额状态图片
      hiddenImg: require("../../assets/img/hidden.png"), //隐藏金额状态图片
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getBusinessOverview();
  },
  watch: {},
  methods: {
    //获取业务概况
    getBusinessOverview() {
      let that = this;
      that.loading = true;
      https
        .fetchPost("agcustInformation/agcustStatistic", {
          agcustId: that.agcustId,
        })
        .then((res) => {
          if (res.code == 200) {
            that.businessData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //隐藏金额
    handleHiddenAmount() {
      this.isHidden = !this.isHidden;
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f8f8f8;
  overflow-x: hidden;
  .busisness-top-box {
    width: 351px;
    height: 238px;
    background: #3672fa;
    border-radius: 6px;
    margin: 12px;
    display: flex;
    flex-direction: column;
    position: relative;
    .hidden-img {
      width: 16px;
      height: 16px;
      position: absolute;
      right: 20px;
      top: 20px;
    }
    .top-info {
      width: 100%;
      height: auto;
      color: #fff;
      margin-left: 16px;
      font-size: 12px;
      .account {
        font-size: 32px;
        .unit {
          font-size: 12px;
        }
      }
    }
    .main-info {
      display: flex;
      align-items: center;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.14),
        rgba(255, 255, 255, 0) 100%
      );
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 12px;
      color: #fff;
      width: 100%;
      height: 64px;
      .flex-item {
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding-left: 16px;
        border-right: 1px solid rgba(231, 231, 231, 0.2);
      }
    }
  }
  .year-data {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    padding: 12px;
    margin-top: 12px;
    .title {
      margin-bottom: 12px;
    }
  }
}
</style>
<style lang="scss">
.cell-group {
  .van-cell {
    display: flex;
    align-items: center;
    .van-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
